package lacaravana.ui

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.html.a
import kotlinx.html.dom.append
import lacaravana.app.Database
import lacaravana.app.appScope
import org.w3c.dom.HTMLElement

object Router {
    private lateinit var db: Database
    private val routes = linkedMapOf<String, Pair<String, suspend (Database) -> Unit>>()
    private var currentJob: Job? = null
    var currentParam: String? = null

    fun register(path: String, label: String, render: suspend (Database) -> Unit) {
        routes[path] = label to render
    }

    fun start(database: Database) {
        db = database
        renderNav()
        window.addEventListener("hashchange", { navigate() })
        navigate()
    }

    private fun navigate() {
        val raw = window.location.hash.removePrefix("#").ifEmpty { routes.keys.firstOrNull() ?: return }
        val parts = raw.split("/", limit = 2)
        val route = parts[0]
        currentParam = parts.getOrNull(1)
        updateActiveNav(route)
        currentJob?.cancel()
        currentJob = appScope.launch { routes[route]?.second?.invoke(db) }
    }

    private fun renderNav() {
        val nav = document.getElementById("nav") ?: return
        nav.innerHTML = ""
        nav.append {
            for ((path, pair) in routes) {
                if (pair.first.isBlank()) continue
                a(href = "#$path") {
                    +pair.first
                    attributes["data-route"] = path
                }
            }
        }
    }

    private fun updateActiveNav(active: String) {
        val links = document.querySelectorAll("#nav a")
        for (i in 0 until links.length) {
            val el = links.item(i) as? HTMLElement ?: continue
            if (el.getAttribute("data-route") == active) el.classList.add("active")
            else el.classList.remove("active")
        }
    }
}
